/**
 * CPU 아키텍쳐 타입을 정의한 ENUM
 * @readonly
 * @enum {Number} CPU 아키텍쳐 타입
 */
export const CPU_ARCHITECTURE_TYPES = {
    /** i686 (32bit) */
    I686: 0,
    /** X86_64 (64Bit) */
    X86_64: 1
}

export default CPU_ARCHITECTURE_TYPES
